module.exports = __webpack_public_path__ + "static/media/alexa.fa226a93.png";